<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='" background-image: url(\"https:\/\/api.tabibekhanevade.ir\/storage\/mezaj\/pngtree-herbal-plants-cosmetic-natural-plant-png-image_4904305.png\");"' class="h-100 bg-primary" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="pt-5 " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="container text-center bg-white p-5 rounded " >
                <template #default>   <m-h1 v-bind='{...{},...{}}' :style='"\n  background: -webkit-linear-gradient(#23A9B3, #03045e);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;"' class="text-center my-5" >
                <template #default>مزاج شما سرد و خشک (سوداوی)است.   </template>
                </m-h1><m-audio v-bind='{...{"audio":"https:\/\/api.tabibekhanevade.ir\/storage\/mezaj\/soda.mp3"},...{}}' :style='""' class="col-8 my-4" ></m-audio><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>ویژگیهای ذیل مربوط به مزاج سرشتی افراد سوداوی می باشد.


اغلب افرادی هستند لاغر با استخوانهای نازک و کشیده، پوست سوداوی ها خشک و رنگ آن از حالت سفید تا سبزه و تیره متغیر است، موی بدن سوداوئی ها کم است و موی سرشان به علت سردی و خشکی زودتر دچار سفیدی یا حالت گندمگون می شود، نبض آن ها تقریباً کند اما سفت و باریک است.

در لمس بدنشان سرد و خشک و پوستشان سفت است. بینی آنان خشک است. خواب کم دارند. تحمل هوای سرد را ندارند و در هوای گرم و فصل بهار راحت ترند. در فصل پاییز خیلی اذیت می شوند. تمایل به خوردن شیرینی و گرمی ها دارد. اینها افراد دقیق و منظم، دور اندیش و محاسبه گر هستند و محتاط می باشند.
بیشتر اوقات دچار نگرانی و دو دلی و وسواس در تصمیم گیریها می شوند، افراد لجباز هستند و در تصمیمات خود بسیار پایدار و ثابت قدم هستند. خیلی اهل فکر وخیال هستند. خود خور و درون گرا وکم انرژی هستند. مستعد افسردگی و وسواس اند.
حرکاتشان از حالات آرام و کند تا معمولی متغیر است با احتیاط و دقت صحبت می کنند در نتیجه کلامشان سریع و بلند نیست، زود سیر شده اما سریعاً گرسنه می شوند، قدرت هاضمه بالایی ندارند. از نظر  قدرت و میل جنسی ضعیفند و تمایلشان به رفتار محبت آمیز بیش از آمیزش جنسی است.
افراد سوداوی مزاج افرادی خشک، کم معاشرت، تابع مقررات، فنی، دقیق، حسابگر، دور اندیش و اغلب سمج هستند، اگر نسبت به کسی کینه داشته باشند از دل بیرون نخواهند کرد. اصرار دارند که هر کاری را به انجام برسانند و جنبه عقلانی امور را بیشتر مد نظر دارند . دوستی با سوداوی ها کار ساده ای نیست .

توصیه و تدابیر:
سودا چون سرد و خشک است افراد سوداوی بايد از غذاهای گرم و تر بیشتر مصرف نمایند.
در میان فصل ها، پایيز فصل سوداست و بهترين فصل براي حجامت افراد سوداوی نیز فصل پایيز است.

علائم غلبه سودا:
اگر تعادل میان اخلاط و مقدار آنها یا کیفیت هر یک از اخلاط بهم بخورد، موجب بیماری در بدن می شود یا به عبارتی موجب غلبه یک خلط بر اخلاط دیگر در بدن می شود که می بایست مورد درمان قرار گیرد که در ذیل علایم غلبه خلط سودا ذکر شده است.

•    لاغری وخشکی وسفتی پوست
•    دو نیم شدن انتهای موهای سر (موخوره)
•    سوزش سر دل
•    اشتهای کاذب(گرسنگی زودرس)
•    سیاه وتیره شدن رنگ پوست بخصوص تیرگی زیر چشم
•    فکر وخیال زیاد (وسواس)
•    خواب سبک و پریدن مکرر از خواب
•    اضطراب و تشویش خاطر (افسردگی)   </template>
                </m-p></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH1 from '@moeinmdn/miw-alpha-components/src/package/Tags/H1'; import mAudio from '@moeinmdn/miw-alpha-components/src/package/Tags/Audio'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mH1,mAudio,mP },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
